import React, { useEffect, useState, useRef, useContext } from "react";
import Sidebar from "../sidebar/sidebar";
import Header from "../header/header";
import "./settings.module.css";
import { PermissionMenuContext } from "../../contextApi/permissionBasedMenuContext";
import NavigationTabs from "../../globalComponents/ui/NavigationTabs";
import Profile from "./Profile";
import Billing from "./Billing";
import SubUsers from "./SubUsers";
import Generator from "./Generator";
import AccessManagement from "./AccessManagement";
import LocationManagement from "./Location";
import FlowCharts from "../flow_charts/FlowCharts";
import DesignationManagement from "./DesignationManagement";
import QuestionFrequency from "./QuestionFrequency";
import Unit from "./Unit";
import Emission from "./Emission";
import Triggers from "./Triggers";
import GHGProtocol from "./GHGProtocol";
import EmailNotificationsAndDueDate from "./EmailNotificationsAndDueDate";
import LockQuestion from "./LockQuestion";
import EmissionKPI from "./EmissionKPI";
import GHGDbKPISettings from "./GHGDbSettingByKpi";
import OwnershipControl from "./OwnershipControl";
import KpisGroup from "./KpisGroup";

const TAB_CONFIG = {
  "Profile Management": { label: "Profile", icon: "user", component: (perms) => <Profile userPermissionList={perms} tab="profile" /> },
  // "Billing Management": { label: "Billing", icon: "credit-card", component: (perms, companyId) => companyId && companyId !== "345" ? <Billing tab="billing" userPermissionList={perms} /> : null },
  // "Lock Question": { label: "Lock question", icon: "lock", component: () => <LockQuestion /> },
  "User Management": { label: "User", icon: "users", component: (perms) => <SubUsers tab="subaccounts" userPermissionList={perms} /> },
  // "Designation Management": { label: "Designation", icon: "briefcase", component: (perms) => <DesignationManagement tab="designation" userPermissionList={perms} /> },
  "Location Management": { label: "Location", icon: "map-pin", component: (perms) => <LocationManagement tab="location" userPermissionList={perms} /> },
  "Permission Management": { label: "Permission", icon: "shield", component: (perms) => <AccessManagement tab="permission" userPermissionList={perms} /> },
  "Create Org Chart": { label: "Chart", icon: "chart-area", component: (perms) => <FlowCharts tab="chart" userPermissionList={perms} /> },
  "Question Frequency": { label: "Frequency", icon: "clock", component: (perms) => <QuestionFrequency tab="frequency" userPermissionList={perms} /> },
  // "GHG Setup": { label: "GHG setup", icon: "leaf", component: (perms) => <GHGProtocol tab="gwp" userPermissionList={perms} /> },
  "Email Notifications": { label: "Email notifications", icon: "bell", component: () => <EmailNotificationsAndDueDate /> },
  "Emission": { label: "Emission", icon: "flame", component: () => <Emission /> },
  "Trigger": { label: "Trigger", icon: "bolt", component: () => <Triggers /> },
  "KPIs": { label: "KPIs", icon: "chart-bar", component: () => <KpisGroup /> },
  "Ownership Control": { label: "Ownership control", icon: "key", component: () => <OwnershipControl /> },
};

const Settings = (props) => {
  const context = useContext(PermissionMenuContext);
  const [menuList, setMenuList] = useState([]);
  const [activeCaption, setActiveCaption] = useState(null);
  const isMounted = useRef(true);
  const [sidebarExpanded, setSidebarExpanded] = useState(true);

  const handleSidebarToggle = (isOpen) => setSidebarExpanded(isOpen);

  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const companyId = currentUser.company_id;

  useEffect(() => {
    const settingsMenu = JSON.parse(localStorage.getItem("menu")) || [];
    const settingsObject = settingsMenu.find((item) => item.caption === "Settings");
    const settingsSubMenu = settingsObject ? settingsObject.sub_menu : [];
    if (isMounted.current) {
      setMenuList(settingsSubMenu);
      if (settingsSubMenu.length > 0 && !activeCaption) {
        setActiveCaption(settingsSubMenu[0].caption);
      }
    }
  }, [context.state]);

  const visibleTabs = menuList
    .filter((item) => {
      if (!TAB_CONFIG[item.caption]) return false;

      if (
        item.caption === "Question Frequency" &&
        !["351", "362"].includes(String(companyId))
      ) {
        return false;
      }

      return true;
    })
    .map((item) => ({
      key: item.caption,
      label: TAB_CONFIG[item.caption].label,
      icon: TAB_CONFIG[item.caption].icon,
      permissions: item.permissions,
      component: TAB_CONFIG[item.caption].component,
    }));

  const activeTab = visibleTabs.find((t) => t.key === activeCaption);

  const renderUI = () => {
    if (!activeTab) return null;
    return activeTab.component(activeTab.permissions, companyId) ?? null;
  };

  return (
    <PermissionMenuContext.Consumer>
      {() => (
        <div
          className="d-flex flex-row mainclass"
          style={{ height: "100vh", overflow: "auto" }}
        >
          <div
            style={{
              flex: sidebarExpanded ? "0 0 21%" : "0 0 60px",
              position: "sticky",
              top: 0,
              zIndex: 999,
              transition: "flex 0.3s ease",
            }}
          >
            <Sidebar
              dataFromParent={props.location.pathname}
              onSidebarToggle={handleSidebarToggle}
            />
          </div>

          <div
            style={{
              flex: sidebarExpanded ? "1 1 79%" : "1 1 calc(100% - 60px)",
              transition: "flex 0.3s ease",
              minHeight: "100vh",
              overflowY: "auto",
            }}
          >
            <div style={{ position: "sticky", top: 0, zIndex: 999 }}>
              <Header />
            </div>

            <div
              className="main_wrapper"
              style={{ width: sidebarExpanded ? "79vw" : "calc(100%)" }}
            >
              <div
                className="inner_wraapper px-3 pt-3 scroll-container w-100"
                style={{ width: "100%" }}
              >
                <NavigationTabs
                  tabs={visibleTabs}
                  activeKey={activeCaption}
                  onChange={setActiveCaption}
                />
                {renderUI()}
              </div>
            </div>
          </div>
        </div>
      )}
    </PermissionMenuContext.Consumer>
  );
};

export default Settings;